var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75C6 8.79297 6.76562 8 7.75 8H18.25C19.207 8 20 8.79297 20 9.75V16.75C20 17.7344 19.207 18.5 18.25 18.5H7.75C6.76562 18.5 6 17.7344 6 16.75V9.75ZM7.3125 9.75V10.3789L12.0156 14.2344C12.5898 14.6992 13.3828 14.6992 13.957 14.2344L18.6875 10.3789V9.75C18.6875 9.53125 18.4688 9.3125 18.25 9.3125H7.75C7.50391 9.3125 7.3125 9.53125 7.3125 9.75ZM7.3125 12.0742V16.75C7.3125 16.9961 7.50391 17.1875 7.75 17.1875H18.25C18.4688 17.1875 18.6875 16.9961 18.6875 16.75V12.0742L14.8047 15.2461C13.7383 16.1211 12.2344 16.1211 11.168 15.2461L7.3125 12.0742Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25.5,
    rx: 12.5,
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCircleIcon);
export default __webpack_public_path__ + "static/media/mail-circle-icon.eb97cba97bb3164c07f10ac91a4fa4fc.svg";
export { ForwardRef as ReactComponent };